import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { IconType, Icons } from '../../../../constants/icons';
import { RewardRedemptionState } from '../../../../models/RewardStore';
import { LoadingSpinner, SvgIcon } from '../../../Molecules';
import './WEARedeemRewardRedemptionTemplate.css';
import { SVGIconType } from '../../../../constants/svgIcon';

type WEARedeemRewardRedemptionTemplateProps = {
  state: RewardRedemptionState;
  onPressMore?: () => void;
};

export const WEARedeemRewardRedemptionTemplate = memo(
  ({ state, onPressMore }: WEARedeemRewardRedemptionTemplateProps) => {
    const { t } = useTranslation();

    return (
      <div className="WEAclub-redeem-redemption">
        {state === RewardRedemptionState.Failed ? (
          <div className="fail">
            <img src={Icons[IconType.Cross]} className="icon" />
            <div className="title">{t('Fail')}</div>
          </div>
        ) : state === RewardRedemptionState.Fulfilled ? (
          <div className="success">
            <SvgIcon
              name={SVGIconType.CircleTick}
              fill={'#0099e6'}
              className={'icon'}
              stroke={'#0099e6'}
            />
            <div className="title">{t('Purchase Successful')}</div>
            <div className="text">{t('You are now a WEA Teacher Member!')}</div>
            {onPressMore && (
              <button className="more" onClick={onPressMore}>
                {t('OK')}
              </button>
            )}
          </div>
        ) : (
          <LoadingSpinner loading={true} />
        )}
      </div>
    );
  },
);
